import { Box, ListItem, ListItemIcon, ListItemProps, ListItemText, styled } from '@mui/material';
import React from 'react';

const SecondaryContentBox = styled(Box)(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: 0.5,
}));

interface AccountItemProps extends ListItemProps {
  icon: JSX.Element;
  primaryText: string;
  secondaryText: string | JSX.Element;
  secondaryAction?: React.ReactNode;
}

export const AccountSettingsItem: React.FC<AccountItemProps> = ({
  icon,
  primaryText,
  secondaryText,
  secondaryAction,
  ...restProps
}) => {
  const secondaryContent = secondaryAction ? (
    <SecondaryContentBox>
      <span>{secondaryText}</span>
      {secondaryAction}
    </SecondaryContentBox>
  ) : (
    secondaryText
  );

  return (
    <ListItem {...restProps}>
      <ListItemIcon>{icon}</ListItemIcon>
      <ListItemText
        primary={primaryText}
        primaryTypographyProps={{ variant: 'callout' }}
        secondary={secondaryContent}
        secondaryTypographyProps={secondaryAction ? { component: 'div' } : undefined}
      />
    </ListItem>
  );
};
